import { CalendarDate } from "../../ProductService/BonificoOrder/BonificoOrderDTO.ts";
import { ListSort, SortDirection } from "../../UI/Table/listUrlParams.ts";
import {
  WithdrawalRequestSource,
  WithdrawalRequestStatus,
} from "./WithdrawalRequestDTO.ts";

export const WITHDRAWAL_REQUEST_SORT_FIELDS = [
  "createdAt",
  "requestedAt",
  "purchasedAt",
  "customer",
] as const;

export type WithdrawalRequestSortField =
  (typeof WITHDRAWAL_REQUEST_SORT_FIELDS)[number];

export const DEFAULT_WITHDRAWAL_REQUESTS_SORT: ListSort<WithdrawalRequestSortField> =
  {
    sortBy: "createdAt",
    sortDirection: "desc",
  };

export const WITHDRAWAL_REQUESTS_PAGE_SIZE = 50;

export type WithdrawalRequestsFilters = {
  statuses?: WithdrawalRequestStatus[];
  sources?: WithdrawalRequestSource[];
  requestedFrom?: CalendarDate;
  requestedTo?: CalendarDate;
  purchasedFrom?: CalendarDate;
  purchasedTo?: CalendarDate;
};

export type WithdrawalRequestsListQuery = WithdrawalRequestsFilters & {
  search?: string;
  sortBy: WithdrawalRequestSortField;
  sortDirection: SortDirection;
  page: number;
  pageSize: number;
};

export function pickWithdrawalRequestsFilters(
  query: WithdrawalRequestsListQuery,
): WithdrawalRequestsFilters {
  return {
    statuses: query.statuses,
    sources: query.sources,
    requestedFrom: query.requestedFrom,
    requestedTo: query.requestedTo,
    purchasedFrom: query.purchasedFrom,
    purchasedTo: query.purchasedTo,
  };
}

export function toWithdrawalRequestsApiParams(
  query: WithdrawalRequestsListQuery,
): Record<string, string | number> {
  const params: Record<string, string | number | undefined> = {
    search: query.search || undefined,
    status: query.statuses?.join(",") || undefined,
    source: query.sources?.join(",") || undefined,
    requestedFrom: query.requestedFrom,
    requestedTo: query.requestedTo,
    purchasedFrom: query.purchasedFrom,
    purchasedTo: query.purchasedTo,
    sortBy: query.sortBy,
    sortDirection: query.sortDirection,
    limit: query.pageSize,
    offset: query.page * query.pageSize,
  };
  return Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined),
  ) as Record<string, string | number>;
}
